import { render, staticRenderFns } from "./TableCustomerUseCoupon.vue?vue&type=template&id=eee5b4c6&scoped=true&"
import script from "./TableCustomerUseCoupon.vue?vue&type=script&lang=js&"
export * from "./TableCustomerUseCoupon.vue?vue&type=script&lang=js&"
import style0 from "./TableCustomerUseCoupon.vue?vue&type=style&index=0&id=eee5b4c6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eee5b4c6",
  null
  
)

export default component.exports